import styled from 'styled-components'

interface IBudgetCategoryCardSubtotalsStyledProps {}

export const BudgetCategoryCardSubtotalsStyled = styled.div<IBudgetCategoryCardSubtotalsStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
`
